function r(e) {
  return e === "outlined" ? {
    borderWidth: "none",
    borderRadius: "small",
    boxShadow: "0 0 0 2px inset"
  } : {
    borderWidth: "none",
    borderRadius: "small"
  };
}
export {
  r as default
};
